/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable react-hooks/exhaustive-deps */

import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCompare } from '../actions/CompareActions';
import { PENDING } from '../actions/constants/RequestStatus';
import { fetchCompareStatus } from '../selectors/CompareSelectors';
export const useCompare = ({
  highlightedProducts
}) => {
  const dispatch = useDispatch();
  const requestStatus = useSelector(fetchCompareStatus);
  useEffect(() => {
    if (!highlightedProducts.length || requestStatus === PENDING) {
      return;
    }
    dispatch(fetchCompare({
      highlightedProducts
    }));
  }, [highlightedProducts]);
};